// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__DevicePixelRatio"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllImages_image",
  "selections": [
    {
      "alias": "imgUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "crop",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "embed",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "height",
          "value": 284
        },
        {
          "kind": "Variable",
          "name": "ratio",
          "variableName": "__relay_internal__pv__DevicePixelRatio"
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 426
        }
      ],
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "type": "ImageAttachment",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
